import { Link, useLocation } from "react-router-dom";
import { mockResellerUser } from "@/mocks/reseller";

interface ResellerSidebarProps {
  open: boolean;
  onClose: () => void;
}

const navItems = [
  { icon: "ri-dashboard-line", label: "Dashboard", to: "/reseller/dashboard" },
  { icon: "ri-links-line", label: "Referral Links", to: "/reseller/links" },
  { icon: "ri-bar-chart-2-line", label: "Sales & Earnings", to: "/reseller/earnings" },
  { icon: "ri-store-2-line", label: "Factory Products", to: "/reseller/products" },
  { icon: "ri-trophy-line", label: "Leaderboard", to: "/reseller/leaderboard" },
  { icon: "ri-paypal-line", label: "PayPal Payouts", to: "/reseller/payouts" },
  { icon: "ri-settings-3-line", label: "Settings", to: "/reseller/dashboard" },
];

const ResellerSidebar = ({ open, onClose }: ResellerSidebarProps) => {
  const location = useLocation();

  return (
    <>
      {open && (
        <div
          className="fixed inset-0 bg-black/50 z-30 lg:hidden"
          onClick={onClose}
        />
      )}
      <aside
        className={`fixed inset-y-0 left-0 z-40 w-64 bg-[#1a0a0a] flex flex-col transition-transform duration-300 ${
          open ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0 lg:static lg:flex`}
      >
        {/* Logo */}
        <div className="p-5 border-b border-white/10">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#D4AF37] to-[#B8860B] flex items-center justify-center">
              <i className="ri-vip-crown-fill text-white text-base"></i>
            </div>
            <div>
              <div className="text-white font-bold text-sm">Crown Prime Mall</div>
              <div className="text-[#D4AF37] text-[10px]">Reseller Portal</div>
            </div>
          </Link>
        </div>

        {/* User Info */}
        <div className="p-4 border-b border-white/10">
          <div className="flex items-center gap-3">
            <img
              src={mockResellerUser.avatar}
              alt={mockResellerUser.name}
              className="w-10 h-10 rounded-full object-cover object-top border-2 border-[#D4AF37]"
            />
            <div className="flex-1 min-w-0">
              <div className="text-white text-xs font-semibold truncate">{mockResellerUser.name}</div>
              <div className="text-gray-400 text-[10px] truncate">{mockResellerUser.handle}</div>
              <div className="flex items-center gap-1 mt-0.5">
                <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37] inline-block"></span>
                <span className="text-[#D4AF37] text-[10px]">{mockResellerUser.tier}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Nav */}
        <nav className="flex-1 p-4 space-y-1">
          {navItems.map((item) => {
            const isActive = location.pathname === item.to;
            return (
              <Link
                key={item.label}
                to={item.to}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors cursor-pointer ${
                  isActive
                    ? "bg-[#D4AF37] text-[#1a0a0a] font-semibold"
                    : "text-gray-400 hover:bg-white/10 hover:text-white"
                }`}
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={item.icon}></i>
                </div>
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="p-4 border-t border-white/10">
          <Link
            to="/reseller/login"
            className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-gray-400 hover:bg-white/10 hover:text-white transition-colors cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-logout-box-line"></i>
            </div>
            Sign Out
          </Link>
        </div>
      </aside>
    </>
  );
};

export default ResellerSidebar;
